var render = function render(){var _vm=this,_c=_vm._self._c;return _c('customer-page',{attrs:{"is-pdf-export-enabled":_vm.isPDfExportEnabled,"is-complete-pdf-export":_vm.isCompletePdfExport},on:{"delete-customer":_vm.deleteCustomer,"get-pdf-report":_vm.getPdfReport}})
}
var staticRenderFns = []

export { render, staticRenderFns }